export const onChangeEntity = (state, payload) => (
  {
    ...state,
    entity: payload
  }
);

export const onChangeLevel = (state, payload) => (
  {
    ...state,
    currentLevel: payload
  }
);

export const onChangeStage = (state, { level, newStage }) => (
  {
    ...state,
    [level]: {
      stage: newStage
    }
  }
);

export const onSignupFailed = (state, payload) => (
  {
    ...state,
    signupLoading: false,
    signupError: payload
  }
);

export const onSignupSuccess = (state, payload) => (
  {
    ...state,
    signupLoading: false,
    signupError: undefined,
    administradoraId: (payload && payload.id) ? payload.id : null,
    onboarding: (payload && payload.onboarding) ? payload.onboarding : null,
    successOutcome: null
  }
);

export const onSignupRequest = (state) => (
  {
    ...state,
    signupLoading: true,
    signupError: undefined
  }
);

export const onOpenExitModal = (state, payload) => (
  {
    ...state,
    exitModal: {
      destination: payload,
      isOpen: true
    }
  }
);

export const onCloseExitModal = (state) => (
  {
    ...state,
    exitModal: {
      destination: undefined,
      isOpen: false
    }
  }
);

export const onOpenPixModal = (state) => (
  {
    ...state,
    pixModal: {
      isOpen: true
    }
  }
);

export const onClosePixModal = (state, payload) => (
  {
    ...state,
    pixModal: {
      isOpen: false
    },
    successOutcome: (payload && payload.outcome) ? payload.outcome : 'analise'
  }
);

export const onUpdateOnboardingStatus = (state, payload) => (
  {
    ...state,
    onboarding: {
      ...(state.onboarding || {}),
      ...(payload || {})
    }
  }
);
